import { gql } from '@apollo/client';

export const TRACK_ACTIVITY = gql`
	mutation TrackActivity($input: TrackActivityInput!) {
		trackActivity(input: $input) {
			statusCode
			success
			message
		}
	}
`;
